export default __webpack_public_path__ + "static/media/cover4.26c15d2f.jpg";